import React from 'react'
import './portfolio.css'

const projects = [
  {
    id: 'aegisai',
    title: 'AegisAI',
    status: 'Prototype - not currently deployed',
    category: 'AI moderation prototype',
    description: 'A tool for reviewing YouTube comments, flagging potentially harmful content, and directing users to report comments on YouTube.',
    stack: 'React, FastAPI, Python, Redis, Supabase, Docker',
    github: 'https://github.com/FlyinPandaa/AegisAI',
    demo: 'https://www.youtube.com/watch?v=sy0-erU7Dwo'
  },
  {
    id: 'soilmateai',
    title: 'SoilMateAI',
    status: 'Hackathon project',
    category: 'HackMerced IX',
    description: 'A team-built AI education project created during a 36-hour hackathon, with a responsive frontend and an AI-powered chatbot concept.',
    stack: 'React, JavaScript, HTML, CSS',
    award: 'Best Use of AI for Education',
    github: 'https://github.com/HackMercedIX/soilmate'
  },
  {
    id: 'simbrain',
    title: 'SimBrain 4 documentation',
    status: 'Documentation migration',
    category: 'Open-source collaboration',
    description: 'Helped restructure and migrate legacy documentation for a neural-network simulator, improving how users find and understand product guidance.',
    stack: 'Markdown, HTML, Jekyll, Docker, Git',
    github: 'https://github.com/FlyinPandaa/simbrain',
    project: 'https://docs.simbrain.net/'
  },
  {
    id: 'tech-fellow-helper',
    title: 'Present',
    status: 'Planned / in progress',
    category: 'Product concept',
    description: 'An early product concept for supporting Tech Fellow workflows. Discovery and scope definition are in progress; this is not a completed product.',
    stack: 'Workflow design, user needs, product thinking'
  }
]

const Portfolio = () => (
  <section id="portfolio">
    <h5>Selected projects</h5>
    <h2>Things I have built and contributed to</h2>

    <div className="container portfolio__container">
      {projects.map(({id, title, status, category, description, stack, award, github, demo, project}) => (
        <article key={id} className="portfolio__item">
          <div className="portfolio__item-topline">
            <span>{category}</span>
            <span className={status.includes('not') || status.includes('in progress') ? 'portfolio__status portfolio__status--in-progress' : 'portfolio__status'}>{status}</span>
          </div>
          <h3>{title}</h3>
          <p>{description}</p>
          <p className="portfolio__stack">{stack}</p>
          {award && <p className="portfolio__award">{award}</p>}
          {(github || demo || project) && (
            <div className="portfolio__item-cta">
              {github && <a href={github} className="btn" target="_blank" rel="noopener noreferrer">GitHub</a>}
              {demo && <a href={demo} className="btn btn-primary" target="_blank" rel="noopener noreferrer">Watch demo</a>}
              {project && <a href={project} className="btn btn-primary" target="_blank" rel="noopener noreferrer">Project site</a>}
            </div>
          )}
        </article>
      ))}
    </div>
  </section>
)

export default Portfolio
